<template>
  <h1 class="my-4">{{ language["portTraffic"] }}</h1>
  <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4" v-if="routes">
    <div class="col" v-for="(item, index) in routes" :key="index">
      <router-link
        class="btn btn-outline-primary btn-lg w-100"
        :to="`./${item}`"
        tag="button"
      >
        {{ language[item] }}
      </router-link>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import { computed } from "vue";

export default {
  props: ["routes"],

  setup() {
    const language = computed(() => store.getters.getLanguage());
    return {
      language,
    };
  },
  mounted() {
    document.title = this.language["portTraffic"];
  },
  name: "Home",
};
</script>
